import { render, staticRenderFns } from "./UpdateMass.vue?vue&type=template&id=32b6c8b4&"
import script from "./UpdateMass.vue?vue&type=script&lang=js&"
export * from "./UpdateMass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports